import { hexToRgb } from "@mui/material";

export function hexToRgba(hex: string, alpha?: number) {
  const rgb = hexToRgb(hex).replace("rgb(", "").replace(")", "");
  return `rgba(${rgb}, ${alpha ? alpha : 1})`;
}
